



























































import type { PropType } from "vue"
import type { stadium_business_stock } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import moment from "moment"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_business_stock> },
    correct : { type: Object, default() { return {} } },
    show    : { type: Object,
      default() {
        return {
          all               : true,
          business_time     : true,
          business_time_hour: true
        }
      }
    },
  },
  data() {
    return {
      data       : {} as stadium_business_stock,
      change     : {} as any,
      change_time: [] as [][],
      times      : [
        {
          start: null as moment.Moment | null,
          end  : null as moment.Moment | null,
          days : [] as string[]
        }
      ],
      days: [
        { label: "周一", value: "1" },
        { label: "周二", value: "2" },
        { label: "周三", value: "3" },
        { label: "周四", value: "4" },
        { label: "周五", value: "5" },
        { label: "周六", value: "6" },
        { label: "周日", value: "0" },
      ],
      rules: {
        business_time: { required: true, message: "请完善营业时间", trigger: "blur" },
      }
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const data = this.$deep_copy(this.form)
        if (data.business_time && data.business_time.length > 0) {
          this.times = []
          for (const time of data.business_time) {
            const temp = time.split(",")
            const t    = temp[0].split("-")
            const days = []
            for (const k in temp) {
              if (Number(k) > 0) {
                days.push(temp[k])
              }
            }
            this.times.push({ start: moment(t[0], "HH:mm"), end: moment(t[1], "HH:mm"), days })
          }
        }
        this.data   = data
      })
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    add_time() {
      this.times.push({
        start: null as moment.Moment | null,
        end  : null as moment.Moment | null,
        days : []
      })
    },
    submit() {
      const times = []
      for (const v of this.times) {
        if (v.start && v.end) {
          const temp = `${v.start.format("HH:mm")}-${v.end.format("HH:mm")}`
          const item = []
          item.push(temp, ...v.days)
          times.push(item.join(","))
        }
      }
      const params = this.$deep_copy(this.data)
      params.business_time = times
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        if (valid) {
          params.estimate_id = this.id
          this.$emit("modify", params)
        }
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  },
  watch: {
    times: {
      handler() {
        const times = []
        for (const v of this.times) {
          if (v.start && v.end) {
            const temp = `${v.start.format("HH:mm")}-${v.end.format("HH:mm")}`
            const item = []
            item.push(temp, ...v.days)
            times.push(item.join(","))
          }
        }
        this.data.business_time = times
      },
      deep: true
    },
    data: {
      handler() {
        this.$nextTick(() => {
          if (this.correct.id == undefined) this.submit()
          this.change = this.$deep_copy(this.correct)
          if (Object.prototype.hasOwnProperty.call(this.change, "business_time")) {
            for (const v of this.change.business_time) {
              const temp = v.split(",")
              this.change_time.push(temp)
            }
          }
        })
      },
      deep   : true
    }
  }
})

